module.exports = __webpack_public_path__ + "img/coding.a315c1d4.svg";